// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "1260px";
var _3 = "1020px";
var _4 = "668px";
var _5 = "1550px";
var _6 = "pfx-CommunityUserSections-module__container--OJcfa";
var _7 = "1140px";
var _8 = "940px";
var _9 = "100%";
var _a = "15px";
var _b = "620px";
var _c = "#f53535";
var _d = "rgba(0,0,0,.2)";
var _e = "rgba(255,255,255,.38)";
var _f = ".38";
var _10 = "rgba(255,255,255,.2)";
var _11 = "#0025ff";
var _12 = "#f60";
var _13 = "#41ead4";
var _14 = "#2cdd78";
var _15 = "#66ab23";
var _16 = "#f5f5f5";
var _17 = "#c3c3c3";
var _18 = "#ececec";
var _19 = "#252525";
var _1a = "#272727";
var _1b = "#c6c6c5";
var _1c = "#333";
var _1d = "#3c3c3c";
var _1e = "#9c9b9b";
var _1f = "#8c8c8c";
var _20 = "#6f6f6e";
var _21 = "#3c3c3b";
var _22 = "#373737";
var _23 = "#6a6a69";
var _24 = "#6f6f6f";
var _25 = "#9f9e9e";
var _26 = "#282828";
var _27 = "#828181";
var _28 = "#1d1d1d";
var _29 = "#979797";
var _2a = "#9c9b9b";
var _2b = "#a7a7a6";
var _2c = "#c6c6c5";
var _2d = "#d8d8d7";
var _2e = "#dddddc";
var _2f = "72px";
var _30 = "40px";
var _31 = "36px";
var _32 = "25px";
var _33 = "18px";
var _34 = "13px";
var _35 = "#0025ff";
var _36 = "rgba(255,255,255,.12)";
var _37 = "#6535f5";
var _38 = "pfx-CommunityUserSections-module__link--PGOZX";
var _39 = "2px";
var _3a = "56px";
var _3b = "56px";
var _3c = "#41ead4";
var _3d = "#f60";
var _3e = "#f83600";
var _3f = "#881f00";
var _40 = "18px";
var _41 = "15px";
var _42 = "red";
var _43 = "13px";
var _44 = "rgba(255,255,255,.07)";
var _45 = "#35465c";
var _46 = "#55acee";
var _47 = "#fff";
var _48 = "#ffce36";
var _49 = "#ffcd00";
var _4a = "red";
export { _1 as "black", _2 as "breakLarge", _3 as "breakMedium", _4 as "breakSmall", _5 as "breakVLarge", _6 as "container", _7 as "containerLarge", _8 as "containerMedium", _9 as "containerMobile", _a as "containerPaddingMobile", _b as "containerSmall", _c as "danger", _d as "darkElement", _e as "disabled", _f as "disabledOpacity", _10 as "extraLightElement", _11 as "facebook", _12 as "google", _13 as "green", _14 as "green2", _15 as "greenColor", _16 as "grey1", _17 as "grey10", _18 as "grey2", _19 as "grey25", _1a as "grey27", _1b as "grey3", _1c as "grey33", _1d as "grey3C", _1e as "grey4", _1f as "grey41", _20 as "grey5", _21 as "grey6", _22 as "grey61", _23 as "grey6A", _24 as "grey6F", _25 as "grey7", _26 as "grey8", _27 as "grey82", _28 as "grey9", _29 as "grey97", _2a as "grey9C", _2b as "greyA7", _2c as "greyC6", _2d as "greyD8", _2e as "greyDd", _2f as "header1", _30 as "header2", _31 as "header3", _32 as "header4", _33 as "header5", _34 as "header6", _35 as "klein", _36 as "lightElement", _37 as "lilac", _38 as "link", _39 as "menuBorder", _3a as "menuHeight", _3b as "menuMobileHeight", _3c as "ocean", _3d as "orange", _3e as "orange2", _3f as "orangeDark", _40 as "paragraph", _41 as "paragraphSmall", _42 as "red", _43 as "subHeaderSmall", _44 as "subtleLightElement", _45 as "tumblr", _46 as "twitter", _47 as "white", _48 as "yellow", _49 as "yellowDeep", _4a as "youtube" }
